import { NotificationsListConfig } from "@ui/context/component-config-context";

import * as styles from "./NotificationsList.theverge.config.css";

const notificationsListConfig: NotificationsListConfig = {
  showNoNotificationsFlag: false,
  showCommunityLogo: false,
  avatarSize: "small",
  headerSize: "medium",
  showLatestHeading: false,
  notificationClassName: styles.notificationItem,
  filtersVariant: "track",
};

export default notificationsListConfig;
